import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IProject, IProjectOverview } from '~/types/project/models'

const apiEntityPath = '/api/projects'

export async function getProjects({ apiPath = '/api/projects' } = {}) {
  const callingMn = getProjects.name
  return httpGet<IProject[]>({ callingMn, apiPath })
}

export async function getProjectOverview(id: string) {
  const callingMn = getProjectOverview.name
  const apiPath = `${apiEntityPath}/${id}/overview`
  return httpGet<IProjectOverview>({ callingMn, apiPath })
}

export async function createProject(entity: IProject) {
  const callingMn = createProject.name
  const apiPath = apiEntityPath
  return httpPost<IProject>({ callingMn, apiPath, entity })
}

export async function updateProject(
  entityData: Partial<IProject>,
  id: TEntityId
) {
  const callingMn = updateProject.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIProject = Partial<IProject>
  return httpPatchMerge<TPartialIProject>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteProject(entityData: IProject) {
  const callingMn = deleteProject.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
